// extracted by mini-css-extract-plugin
export default {"header":"App_header__NiW2c","footer":"App_footer__FwuVS","rounded-button":"App_rounded-button__mHxk8"};